//================================================
// Authentication
//================================================
export const register = (state) => state.register;
export const sendValidationMail = (state) => state.sendValidationMail;
export const getValidationMailStatus = (state) => state.getValidationMailStatus;

//================================================
// Reset Password
//================================================
export const resetPasswordWithOld = (state) => state.resetPasswordWithOld;
export const resetPasswordWithToken = (state) => state.resetPasswordWithToken;
export const sendResetPasswordTokenEmail = (state) =>
  state.sendResetPasswordTokenEmail;

//================================================
// Widgets
//================================================
export const getTrendingTickersRes = (state) => state.getTrendingTickers;
export const getTrendingIndicesRes = (state) => state.getTrendingIndices;
export const getAllTrendingIndicesRes = (state) => state.getAllTrendingIndices;

//================================================
// Feed
//================================================
export const getHomeForYouFeedRes = (state) => state.getFeed;
export const getHomeNewsFeedRes = (state) => state.getHomeNewsFeed;
export const countNewFeedRes = (state) => state.countNewFeed;

//================================================
// Industry
//================================================
export const getIndustriesRes = (state) => state.getIndustries;
export const followIndustryToggleRes = (state) => state.followIndustryToggle;

//================================================
// Messages
//================================================
export const getMessageNotificationsAllRes = (state) =>
  state.getMessageNotificationsAll;
export const markAsReadMessageNotificationsAllRes = (state) =>
  state.markAsReadMessageNotificationsAll;

//================================================
// News
//================================================
export const getNewsRes = (state) => state.getNews;
export const getCryptoNewsRes = (state) => state.getCryptoNews;
export const getNewsDetailRes = (state) => state.getNewsDetail;

//================================================
// Tickers
//================================================
export const getCryptoTickerStockValue = (state) =>
  state.getCryptoTickerStockValue;
export const getTickerStockValue = (state) => state.getTickerStockValue;

//================================================
// Profile
//================================================
export const getProfileByIdRes = (state) => state.getProfileById;
export const getSymbolByIdRes = (state) => state.getSymbolById;
export const createProfileRes = (state) => state.createProfile;
export const updateProfileRes = (state) => state.updateProfile;
export const uploadProfileAvatarRes = (state) => state.uploadProfileAvatar;
export const uploadProfileHeaderRes = (state) => state.uploadProfileHeader;
export const validateProfileProfilenameRes = (state) =>
  state.validateProfileProfilename;
export const getProfileIdFromNameRes = (state) => state.getProfileIdFromName;
export const publicValidateProfileProfilenameRes = (state) =>
  state.publicValidateProfileProfilename;
export const publicValidateUserEmailRes = (state) =>
  state.publicValidateUserEmail;
export const publicGetuserFromProfileNameRes = (state) =>
  state.publicGetUserFromProfileName;
export const followProfileRes = (state) => state.followProfile;
export const followStockChangeRes = (state) => state.followStockChange;
export const followedIdustriesRes = (state) => state.followedIdustries;
export const rateProfileRes = (state) => state.rateProfile;
export const getProfileFollowedRes = (state) => state.getProfileFollowed;
export const getProfileFollowersRes = (state) => state.getProfileFollowers;
export const getCompanySymbolsRes = (state) => state.getCompanySymbols;
export const getCompanySymbolsV2Res = (state) => state.getCompanySymbolsV2;
export const getMultipleCompanySymbolsRes = (state) =>
  state.getMultipleCompanySymbols;
export const getCryptoSymbolsRes = (state) => state.getCryptoSymbols;
export const getPrimaryTickerFundamentalsRes = (state) =>
  state.getPrimaryTickerFundamentals;
export const getTickerFundamentalsRes = (state) => state.getTickerFundamentals;
export const seenWTPModalRes = (state) => state.seenWTPModal;
export const seenPortfolioGuideDrawerRes = (state) =>
  state.seenPortfolioGuideDrawer;
export const seenHomeGuideDrawerRes = (state) => state.seenHomeGuideDrawer;
export const deleteProfileRes = (state) => state.deleteProfile;
export const getCompanyPortfoliosRes = (state) => state.getCompanyPortfolios;
export const getCompanyProfileCommentsRes = (state) =>
  state.getCompanyProfileComments;
export const getProfileFollowedCountPerTypeRes = (state) =>
  state.getProfileFollowedCountPerType;
export const lastFetchedCompanyId = (state) => state.lastFetchedCompanyId;

//================================================
// Users
//================================================
export const updateUsersMeRes = (state) => state.updateUsersMe;
export const patchUserBirthdateRes = (state) => state.patchUserBirthdate;
export const deleteUserRes = (state) => state.deleteUser;

//================================================
// Search
//================================================
export const searchRes = (state) => state.search;
export const allSuggestedIndices = (state) => state.getAllSuggestedIndices;
export const allSuggestedStocks = (state) => state.allSuggestedStocks.data;

//================================================
// Portfolio
//================================================
export const createPortfolioRes = (state) => state.createPortfolio;
export const getMainLeaguePortfolioTopGainersRes = (state) =>
  state.getMainLeaguePortfolioTopGainers;
export const portfolioSearchRes = (state) => state.portfoliosSearch;
export const getPortfolioComparisonGraphInfoRes = (state) =>
  state.getPortfolioComparisonGraphInfo;
export const orderPortfoliosRes = (state) => state.orderPortfolios;
export const getPortfolioByIdRes = (state) => state.getPortfolioById;
export const removePortfolioRes = (state) => state.removePortfolio;
export const likePortfolioRes = (state) => state.likePortfolio;
export const updatePortfolioRes = (state) => state.updatePortfolio;
export const getPortfolioGraphRes = (state) => state.getPortfolioGraph;
export const getMyPortfoliosRes = (state) => state.getMyPortfolios;
export const getProfilePortfoliosRes = (state) => state.getProfilePortfolios;
export const createOperationRes = (state) => state.createOperation;
export const createCashOperationRes = (state) => state.createCashOperation;
export const addPortfolioItemRes = (state) => state.addPortfolioItem;
export const getTickerStockValueRes = (state) => state.getTickerStockValue;
export const getSimilarTickersRes = (state) => state.getSimilarTickers;
export const getFavoritePortfolioRes = (state) => state.getFavoritePortfolio;
export const getMyFavoritePortfoliosRes = (state) =>
  state.getMyFavoritePortfolios;
export const getTickerStockRangeValueRes = (state) =>
  state.getTickerStockRangeValue;
export const getTickerStockRangeWithOverallRes = (state) =>
  state.getTickerStockRangeWithOverall;
export const getMultipleTickerStockValueRes = (state) =>
  state.getMultipleTickerStockValue;
export const getMultipleTickerStockValueWithOverallRes = (state) =>
  state.getMultipleTickerStockValueWithOverall;
export const getTeamPortfolioProfilesRes = (state) =>
  state.getTeamPortfolioProfiles;
export const updateTeamPortfolioProfileRes = (state) =>
  state.updateTeamPortfolioProfile;
export const deleteTeamPortfolioProfileRes = (state) =>
  state.deleteTeamPortfolioProfile;
export const createTeamPortfolioProfileRes = (state) =>
  state.createTeamPortfolioProfile;
export const favoritePortfolioRes = (state) => state.favoritePortfolio;
export const getPortfolioCommentsRes = (state) => state.getPortfolioComments;
export const togglePortfolioRankNotifications = (state) =>
  state.togglePortfolioRankNotifications;
export const validatePortfolioOperation = (state) =>
  state.validatePortfolioOperation;

//================================================
// Post
//================================================
export const getPostByIdRes = (state) => state.getPostById;
export const getPostsRes = (state) => state.getPosts;
export const getPostRepliesRes = (state) => state.getPostReplies;
export const createPostRes = (state) => state.createPost;
export const updatePostRes = (state) => state.updatePost;
export const uploadPostImageRes = (state) => state.uploadPostImage;
export const getPostImageForPreviewRes = (state) =>
  state.getPostImageForPreview;
export const uploadPortfolioImageRes = (state) => state.uploadPortfolioImage;
export const likePostRes = (state) => state.likePost;
export const favoritePostRes = (state) => state.favoritePost;
export const getMyFavoritesPostRes = (state) => state.getMyFavoritesPost;
export const getProfilePostsRes = (state) => state.getProfilePosts;
export const getProfilePostFeedRes = (state) => state.getProfilePostFeed;
export const getProfileRepliesFeedRes = (state) => state.getProfileRepliesFeed;
export const deleteUserPostRes = (state) => state.deleteUserPost;
export const getLeagueFeedRes = (state) => state.getLeagueFeed;

//================================================
// Notifications
//================================================
export const notificationsRes = (state) => state.notifications;
export const handleReadAllNotificationRes = (state) =>
  state.handleReadAllNotification;
export const handleReadMultipleNotifications = (state) =>
  state.handleReadMultipleNotifications;
export const handleReadNotificationRes = (state) =>
  state.handleReadNotification;
export const removeNotificationRes = (state) => state.removeNotification;
export const notificationsCountRes = (state) => state.notificationsCount;
export const notificationTypes = (state) => state.notificationTypes;
export const pushNotificationSettings = (state) =>
  state.pushNotificationSettings;

//================================================
// Onboarding
//================================================
export const tutorialNextStepRes = (state) => state.tutorialNextStep;
export const completeTutorialRes = (state) => state.completeTutorial;
export const userOnboardingQuestions = (state) =>
  state.getUserOnboardingQuestions;
export const userOnboardingAnswers = (state) =>
  state.getUserOnboardingAnswersByProfileId;
export const finishOnboardingTooltipsTutorial = (state) =>
  state.finishOnboardingTooltipsTutorial;

//================================================
// Recommendations
//================================================
export const getRecommendedProfilesRes = (state) =>
  state.getRecommendedProfiles;
export const getRecommendedCompaniesRes = (state) =>
  state.getRecommendedCompanies;
export const getMutualFollowsRecommendationRes = (state) =>
  state.getMutualFollowsRecommendation;
export const getMutualIndustriesRecommendationRes = (state) =>
  state.getMutualIndustriesRecommendation;
export const getSimilarCompaniesRecommendationRes = (state) =>
  state.getSimilarCompaniesRecommendation;
export const getCompanyFollowersRecommendationRes = (state) =>
  state.getCompanyFollowersRecommendation;

export const getTopInvestorsRes = (state) => state.getTopInvestors;
//================================================
// Languages
//================================================
export const getNewsSuscribedLanguagesRes = (state) =>
  state.getNewsSuscribedLanguages;

//================================================
// Stocks
//================================================
export const searchStocksRes = (state) => state.searchStocks;

//================================================
// Leagues
//================================================
export const createAdminLeagueRes = (state) => state.createAdminLeague;
export const searchLeaguesRes = (state) => state.searchLeagues;
export const getPendingProfileInvitationsRes = (state) =>
  state.getPendingProfileInvitations;
export const answerLeagueInvitationRes = (state) =>
  state.answerLeagueInvitation;
export const getMyLeaguePortfoliosRes = (state) => state.getMyLeaguePortfolios;
export const getLeaguePortfoliosRes = (state) => state.getLeaguePortfolios;
export const submitLeaguePasswordRes = (state) => state.submitLeaguePassword;
//================================================
// Academy guides
//================================================
export const searchAcademyGuidesRes = (state) => state.searchAcademyGuides;
//================================================
// Portfolio Orders
//================================================
export const createPortfolioOrderRes = (state) => state.createPortfolioOrder;
export const cancelPortfolioOrderRes = (state) => state.cancelPortfolioOrder;
export const getPortfolioOrdersRes = (state) => state.getPortfolioOrders;
//================================================
// Currency conversions
//================================================
export const convertCurrencyRes = (state) => state.convertCurrency;
